import React, { useState, useEffect, useRef } from "react";
import Header from "../Components/Header/Header";
import { Tab, Nav, Form } from "react-bootstrap";
import { apiCall, getCurrentUser } from "../Api/auth";
import HeaderAdmin from "../../src/Components/HeaderAdmin/Header";
import { Link } from "react-router-dom";
import { getremotefittingdatabyuser, getunsubmitfittingdata } from "../Api/iron";
import { updateuser } from "../Api/staff";
import Modal from 'react-bootstrap/Modal';
import { Spinner } from "react-bootstrap";
import ButtonList from "../Components/ButtonList/ButtonList";
import { FaCalendarAlt } from "react-icons/fa";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { getcountriesforfitter, getstates, getcities, } from '../Api/iron'

import './user_dashboard.css';
import { FaCheck } from "react-icons/fa";
import { getremoteInquirydataApi, createRemotefittingdata } from '../Api/iron';
import RemoateFitting from "../Components/RemoateFitting/RemoateFitting";
import FittingRates from "../Components/FittingRates/FittingRates";
function UserDashboard() {

    const playerRefs = useRef([]);
    const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);

    const handlePlay = (index) => {
        if (currentPlayingIndex !== null) {
            // Pause the currently playing video
            pauseVideo(currentPlayingIndex);
        }

        playVideo(index);
    };

    const playVideo = (index) => {
        const player = playerRefs.current[index];
        if (player) {
            player.contentWindow.postMessage(
                JSON.stringify({
                    method: 'play',
                    value: null
                }),
                '*'
            );

            setCurrentPlayingIndex(index);
        }
    };

    const pauseVideo = (index) => {
        const player = playerRefs.current[index];
        if (player) {
            player.contentWindow.postMessage(
                JSON.stringify({
                    method: 'pause',
                    value: null
                }),
                '*'
            );

            setCurrentPlayingIndex(null);
        }
    };


    const videos = [
        {
            src: 'https://player.vimeo.com/video/844417814?h=b2407d1914&badge=0&autopause=0&player_id=0&app_id=58479&controls=1',
            title: 'Club Fitting',
            subtitle: 'Equipment',
            description: 'One on one time with a Certified Fitter who has all the tech and equipment options needed to find your optimal set up.'
        },
        {
            src: 'https://player.vimeo.com/video/844426147?h=b2407d1914&badge=0&autopause=0&player_id=0&app_id=58479&controls=1',
            title: 'Golf Lessons',
            subtitle: 'Instruction',
            description: 'We maximize your game. Coaching and instruction isn\'t always technique. We look at all facets to create your plan.'
        }
    ];
    const [isOpen, setIsOpen] = useState(false);
    const [isOpen1, setIsOpen1] = useState(false);
    const handleToggle = () => {
        setIsOpen(!isOpen);
    };
    const handleToggle1 = () => {
        setIsOpen1(!isOpen1);
    };

    const [errors, setErrors] = useState([]);
    const [validated, setValidated] = useState(false);
    const [apicall, setApicall] = useState(false);
    const [user_id, setUser_id] = useState(0);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [show, setShow] = useState(false);
    const [apiNewcall, setApiNewcall] = useState(false);

    const [width, setWidth] = useState(window.innerWidth);

    const [dexterity, setDexterity] = useState(0);
    const [heightft, setHeightft] = useState(0);
    const [heightin, setHeightin] = useState(0);

    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');

    const [userdata, setUserdata] = React.useState({
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        height_ft: "",
        height_in: "",
        dexterity: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        country: ""
    });

    const [edittrue, setEdittrue] = useState(false);

    const [remotefitting, setRemotefitting] = useState([]);
    const [remotefittingunsubmit, setRemotefittingunsubmit] = useState(null);
    const [remotefittingvideos, setRemotefittingvideos] = useState(null);
    const [showremotefitting, setShowRemotefitting] = useState(false);


    const handleedittrue = () => {
        setEdittrue(!edittrue);
    }


    useEffect(() => {
        getallcountry();
        const getCurrentUserdata = getCurrentUser();
        // setUserdata(getCurrentUserdata.user);
        // setUser_id(getCurrentUserdata.user._id);


        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
            setDexterity(getCurrentUserdata.user.dexterity);
            setHeightft(getCurrentUserdata.user.height_ft);
            setHeightin(getCurrentUserdata.user.height_in);
            setUser_id(getCurrentUserdata.user._id);
            setAddress(getCurrentUserdata.user.address);
            setCity(getCurrentUserdata.user.city);
            setState(getCurrentUserdata.user.state);
            setZip(getCurrentUserdata.user.zip);

            getallstatefunc(getCurrentUserdata.user.country);
            getallcityfunc(getCurrentUserdata.user.state);
        } else {
            console.error("Current user data is null or undefined");
        }

    }, []);

    useEffect(() => {
        if (user_id != 0) {
            getfittingdata();
            unsubmitfittingdata();
        }
    }, [user_id])

    const dataChange = (e) => {
        const { name, value } = e.target;
        setUserdata({ ...userdata, [name]: value });
    }

    const getfittingdata = () => {
        const data = {
            user_id: user_id
        }
        getremotefittingdatabyuser(data).then((response) => {
            if (!response.data.status) {
                setErrors(response.data.error);
                alert(response.data.message);
            } else {
                const data = response.data.data;
                setRemotefitting(data);
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    const unsubmitfittingdata = () => {
        const data = {
            user_id: user_id
        }
        getunsubmitfittingdata(data).then((response) => {
            if (!response.data.status) {
                setErrors(response.data.error);
                // alert(response.data.message); 
            } else {
                const data = response.data.data;
                setRemotefittingunsubmit(data);
                setRemotefittingvideos(data.remotefittingimage);
                setShowRemotefitting(data.submitted_status);
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();
        userdata._id = user_id;
        userdata.dexterity = dexterity;
        userdata.height_ft = heightft;
        userdata.height_in = heightin;
        updateuser(userdata, e).then((res) => {
            console.log(res);
            if (!res.data.status) {
                setErrors(res.data.error);
                alert(res.data.message);
            } else {
                localStorage.setItem("user", JSON.stringify(res.data.data));
                const formdata = res.data.data;
                setUserdata(formdata);
                setDexterity(formdata.dexterity);
                setHeightft(formdata.height_ft);
                setHeightin(formdata.height_in);
                handleShow();
                // window.location.href = "/user-dashboard";
            }
        }).catch((err) => {
            alert(err);
        }).finally(() => {
            setApicall(false);
            setEdittrue(false);
        });
        setValidated(true);
    }

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    })

    const checkPreferredClubs = () => {
        // Check if remotefittingunsubmit and remotefittingdata are defined
        if (!remotefittingunsubmit?.remotefittingdata) return false;

        for (let i = 1; i <= 8; i++) {
            // Check if preferred_club exists in remotefittingdata
            if (!remotefittingunsubmit.remotefittingdata[`step${i}`]?.preferred_club) {
                return false;
            }
        }
        return true;
    };

    const checkCameraImages = () => {
        // Check if remotefittingunsubmit and remotefittingdata are defined
        if (!remotefittingunsubmit?.remotefittingdata) return false;

        for (let i = 1; i <= 8; i++) {
            for (let j = 1; j <= 3; j++) {
                // Check if cameraimage exists in remotefittingdata
                if (!remotefittingunsubmit.remotefittingdata[`step${i}`]?.[`iron${j}`]?.cameraimage) {
                    return false;
                }
            }
        }
        return true;
    };

    const [show03, setShow03] = useState(false);

    const handleClose03 = () => setShow03(false);
    const handleShow03 = () => setShow03(true);

    useEffect(() => {
        if (remotefittingunsubmit) {
            //setShowRemotefitting(true);
            localStorage.setItem('project_id', remotefittingunsubmit?._id)
        }
    }, [remotefittingunsubmit])

    let remotefittingdata = remotefittingunsubmit?.remotefittingdata;

    const [loadingButtons, setLoadingButtons] = useState({});

    const checkprec = (project_id) => {
        setLoadingButtons((prev) => ({ ...prev, [project_id]: true }));
        getremoteInquirydataApi({ id: project_id }).then((res) => {
            if (res?.code === 200) {
                const submitteddata = res.data.data;
                if (submitteddata?.fittingdata) {
                    setLoadingButtons((prev) => ({ ...prev, [project_id]: false }));
                    window.location.href = `/prescription-view/${project_id}`;
                } else {
                    setLoadingButtons((prev) => ({ ...prev, [project_id]: false }));
                    handleShow03();
                }
            } else {
                setLoadingButtons((prev) => ({ ...prev, [project_id]: false }));
            }
        }).catch((err) => {
            setLoadingButtons((prev) => ({ ...prev, [project_id]: false }));
            alert(err);
        });
    };

    const [newapicall, setNewApicall] = useState(false);

    const creatremotefitting = () => {
        setNewApicall(true)
        const data = {
            user_id: user_id,
            address: address,
            zip: zip,
            city: city,
            state: state,
            start_point: 'user',
            remotefittingimage: {}
        }
        createRemotefittingdata(data).then((res) => {
            if (res?.code === 200) {
                const project_id = res.data.data._id;
                setNewApicall(false);

                window.location.href = `/remote_fittings_camera/${user_id}`;

            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    const [loginusercallback, setloginusercallback] = useState(null);
    const [showpopup, setShowPopup] = useState(0);




    const [stateLoading, setStateLoading] = useState(false);
    const [cityLoading, setCityLoading] = useState(false);

    const [countrylist, setCountrylist] = useState([]);
    const [statelist, setStatelist] = useState([]);
    const [citylist, setCitylist] = useState([]);

    const getallcountry = () => {
        getcountriesforfitter()
            .then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    const data = response.data.data;
                    setCountrylist(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getallstatefunc = (country_id) => {
        setStateLoading(true)
        const data = {
            country_id: country_id,
        };
        getstates(data)
            .then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    setStateLoading(false)
                    const data = response.data.data;
                    setStatelist(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getallcityfunc = (state_id) => {
        setCityLoading(true);
        const data = {
            state_id: state_id,
        };
        getcities(data)
            .then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    setCityLoading(false);
                    const data = response.data.data;
                    setCitylist(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };


    return (
        <>

            <Modal
                show={show03}
                onHide={handleClose03}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <h2 className="text-center mb-3">
                        Prescripation data is not avaiable!
                    </h2>

                    <button type="button" className="btn btn-modal-view" onClick={handleClose03}>
                        OK, got it!
                    </button>
                </Modal.Body>
            </Modal>

            <div className="user-dashboard-design">
                <div className="main-page-body-content-header">
                    <HeaderAdmin />
                </div>
                <div className="dashboard-container d-flex user-deshboard">
                    <div className="main-container">
                        <div className="main-page-body-content">
                            <div className="main-page-body-content-body">
                                <div className="main-page-body-content-body-container">
                                    <div className="container-fluid">
                                        {/* <div class="container-fluid text-center user-dash-top col-12"> */}
                                        {


                                            (showremotefitting === false) ? (
                                                <div></div>
                                            ) : (
                                                <>
                                                    <img className='col-12 text-white remote-text' style={{ textAlign: 'center' }} src={require('../assets/images/remote-fitting-logo.png')} alt="logo" />

                                                    <div className="stepper-container">
                                                        {/* Step 1: Film Swing */}
                                                        <div
                                                            className={`step ${remotefittingdata?.swingdata?.status
                                                                ? "active"
                                                                : remotefittingdata?.currentStep === "Film Swing"
                                                                    ? "in-progress"
                                                                    : ""
                                                                }`}
                                                        >
                                                            <p className="step-label">Film Swing</p>
                                                            <div
                                                                className="step-circle"
                                                                style={{
                                                                    backgroundColor: remotefittingdata?.swingdata?.status ? "#99EA24" : "#404650",
                                                                }}
                                                            >
                                                                <FaCheck color="#000" />
                                                            </div>
                                                        </div>

                                                        {/* Step 2: Iron Test */}
                                                        <div
                                                            className={`step ${remotefittingdata?.irondata?.status
                                                                ? "active"
                                                                : remotefittingdata?.currentStep === "Iron Test"
                                                                    ? "in-progress"
                                                                    : ""
                                                                }`}
                                                            style={{
                                                                borderTopColor:
                                                                    remotefittingdata?.swingdata?.status || remotefittingdata?.currentStep === "Iron Test"
                                                                        ? "#99EA24"
                                                                        : "#404650",
                                                            }}
                                                        >
                                                            <p className="step-label">Iron Test</p>
                                                            <div
                                                                className="step-circle"
                                                                style={{
                                                                    backgroundColor: remotefittingdata?.irondata?.status
                                                                        ? "#99EA24"
                                                                        : "#404650",
                                                                }}
                                                            >
                                                                <FaCheck color="#000" />
                                                            </div>
                                                        </div>

                                                        {/* Step 3: Ball Data */}
                                                        <div
                                                            className={`step ${remotefittingdata?.balldata?.status
                                                                ? "active"
                                                                : remotefittingdata?.currentStep === "Ball Data"
                                                                    ? "in-progress"
                                                                    : ""
                                                                }`}
                                                            style={{
                                                                borderTopColor:
                                                                    remotefittingdata?.irondata?.saveIronStatus || remotefittingdata?.currentStep === "Ball Data"
                                                                        ? "#99EA24"
                                                                        : "#404650",
                                                            }}
                                                        >
                                                            <p className="step-label">Ball Data</p>
                                                            <div
                                                                className="step-circle"
                                                                style={{
                                                                    backgroundColor: remotefittingdata?.balldata?.status
                                                                        ? "#99EA24"
                                                                        : "#404650",
                                                                }}
                                                            >
                                                                <FaCheck color="#000" />
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <Link to={`/remote_fittings_camera/${user_id}`}>
                                                        <button className='btn save-attach-btn col-12 py-4 mt-5' style={{ backgroundColor: '#99EA24' }}>Open Fitting</button>
                                                    </Link>
                                                </>
                                            )
                                        }


                                        {/* </div> */}
                                        <div className="sec-tab mt-5">
                                            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <Nav variant="pills" className="flex-row user_desk_tab">
                                                            <Nav.Item>
                                                                <Nav.Link eventKey="first">Profile</Nav.Link>
                                                            </Nav.Item>
                                                            <Nav.Item>
                                                                <Nav.Link eventKey="second">Scripts</Nav.Link>
                                                            </Nav.Item>
                                                            <Nav.Item>
                                                                <Nav.Link eventKey="third">Bookings</Nav.Link>
                                                            </Nav.Item>
                                                        </Nav>
                                                    </div>
                                                    <div className="col-sm-12">
                                                        <Tab.Content>
                                                            <Tab.Pane eventKey="first">
                                                                <Form noValidate validated={validated} onSubmit={handleUpdateSubmit}>
                                                                    {/* <div class="sec-header-dash dashboard-sec "> */}
                                                                    <div class="sec-dashboard-header-title mt-4 mb-0 d-flex justify-content-between align-items-center">
                                                                        <div class="box-title mb-0" style={{ color: '#ffffff' }}>
                                                                            <h3>My Profile</h3>
                                                                        </div>
                                                                        <div class="content-box-btn">
                                                                            {
                                                                                edittrue ? (
                                                                                    apicall ? (
                                                                                        <button className="btn btn-save">
                                                                                            <Spinner animation="border" className="border-black" />
                                                                                        </button>
                                                                                    ) : (
                                                                                        <div className="sec-btn-group d-flex justify-content-end">
                                                                                            <button className="btn btn-save" type="submit">Save data</button>
                                                                                        </div>
                                                                                    )
                                                                                ) : (
                                                                                    <button className="btn btn-add" onClick={handleedittrue}>Edit</button>
                                                                                )
                                                                            }

                                                                        </div>
                                                                    </div>
                                                                    {/* </div> */}
                                                                    <div className="dashboard-sec">
                                                                        <div className="container-fulid">
                                                                            <fieldset>
                                                                                <div className="tab-box-section user-dash">
                                                                                    <div className="form-box-inner">
                                                                                        <div className="row gx-2">
                                                                                            <div className="col-6 col-md-6 form-group" controlid="validationCustom01">
                                                                                                <input type="text"
                                                                                                    className="form-control dashboard-input-box-3"
                                                                                                    placeholder="First name"
                                                                                                    required
                                                                                                    disabled={!edittrue}
                                                                                                    value={userdata.firstname}
                                                                                                    onChange={(e) => dataChange(e)}
                                                                                                    name={"firstname"}
                                                                                                />
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please enter a first name.
                                                                                                </Form.Control.Feedback>
                                                                                            </div>
                                                                                            <div className="col-6 col-md-6 form-group" controlid="validationCustom02">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    value={userdata.lastname}
                                                                                                    onChange={(e) => dataChange(e)}
                                                                                                    disabled={!edittrue}
                                                                                                    name="lastname"
                                                                                                    className="form-control dashboard-input-box-3"
                                                                                                    placeholder="Last name"
                                                                                                    required
                                                                                                />
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please enter a last name.
                                                                                                </Form.Control.Feedback>
                                                                                            </div>
                                                                                            <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                                                <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={!edittrue} value={heightft} onChange={(e) => setHeightft(e.target.value)} aria-label="Default select example">
                                                                                                    <option value={0}>ft.</option>
                                                                                                    <option value="4">4 ft.</option>
                                                                                                    <option value="5">5 ft.</option>
                                                                                                    <option value="6">6 ft.</option>
                                                                                                    <option value="7">7 ft.</option>
                                                                                                </select>
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please select a ft.
                                                                                                </Form.Control.Feedback>
                                                                                            </div>
                                                                                            <div className="col-6 col-md-3 form-group" controlid="validationCustom01">
                                                                                                <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={!edittrue} value={heightin} onChange={(e) => setHeightin(e.target.value)} aria-label="Default select example">
                                                                                                    <option value={0}>in.</option>
                                                                                                    <option value="1">0 in.</option>
                                                                                                    <option value="2">1 in.</option>
                                                                                                    <option value="3">2 in.</option>
                                                                                                    <option value="4">3 in.</option>
                                                                                                    <option value="5">4 in.</option>
                                                                                                    <option value="6">5 in.</option>
                                                                                                    <option value="7">6 in.</option>
                                                                                                    <option value="8">7 in.</option>
                                                                                                    <option value="9">8 in.</option>
                                                                                                    <option value="10">9 in.</option>
                                                                                                    <option value="11">10 in.</option>
                                                                                                    <option value="12">11 in.</option>
                                                                                                </select>
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please select a in.
                                                                                                </Form.Control.Feedback>
                                                                                            </div>
                                                                                            <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                                                                                <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={!edittrue} value={dexterity} onChange={(e) => setDexterity(e.target.value)} aria-label="Default select example">
                                                                                                    <option value={0}>Dexterity</option>
                                                                                                    <option value="1">Right Handed</option>
                                                                                                    <option value="2">Left Handed</option>
                                                                                                </select>
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please select a Dexterity
                                                                                                </Form.Control.Feedback>
                                                                                            </div>
                                                                                            <div className="col-md-12 form-group" controlid="validationCustom03">
                                                                                                <input type="tel" className="form-control dashboard-input-box-3"
                                                                                                    name={"phone"}
                                                                                                    required
                                                                                                    disabled={!edittrue}
                                                                                                    value={userdata.phone}
                                                                                                    onChange={(e) => dataChange(e)}
                                                                                                />
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please enter a 8-digit phone number.
                                                                                                </Form.Control.Feedback>
                                                                                            </div>
                                                                                            <div className="col-md-12 form-group" controlid="validationCustom04">
                                                                                                <input type="email" className="form-control dashboard-input-box-3"
                                                                                                    name="email"
                                                                                                    disabled={!edittrue}
                                                                                                    value={userdata.email}
                                                                                                    onChange={(e) => dataChange(e)}
                                                                                                />
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please choose a email.
                                                                                                </Form.Control.Feedback>
                                                                                            </div>
                                                                                            <div className="col-md-12 form-group" controlid="validationCustom04">
                                                                                                <input type="text" className="form-control dashboard-input-box-3" name="address" value={userdata.address} onChange={(e) => dataChange(e)} placeholder="Street Address, Apt. #" required disabled={!edittrue} />
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please choose a street address.
                                                                                                </Form.Control.Feedback>
                                                                                            </div>
                                                                                            <div className="col-md-12 form-group" controlid="validationCustom04">

                                                                                                <select disabled={!edittrue} name="country" value={userdata.country} onChange={(e) => {
                                                                                                    dataChange(e);
                                                                                                    setState("");
                                                                                                    setCity("");
                                                                                                    getallstatefunc(
                                                                                                        e.target.value
                                                                                                    );
                                                                                                }}
                                                                                                    class="form-control dashboard-input-box-3"
                                                                                                    aria-label="Default select example"
                                                                                                >
                                                                                                    <option value={0}>
                                                                                                        Country
                                                                                                    </option>
                                                                                                    {countrylist &&
                                                                                                        countrylist.map(
                                                                                                            (item) => (
                                                                                                                <option
                                                                                                                    value={item._id}
                                                                                                                    key={item._id}
                                                                                                                >
                                                                                                                    {item.name}
                                                                                                                </option>
                                                                                                            )
                                                                                                        )}
                                                                                                </select>
                                                                                            </div>
                                                                                            <div className="col-4 col-md-6 form-group mb-0" controlid="validationCustom01">
                                                                                                {/* <input type="text" name="city" className="form-control dashboard-input-box-3" value={userdata.city} onChange={(e) => dataChange(e)} placeholder="City" required disabled={!edittrue} />
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please enter City
                                                                                                </Form.Control.Feedback> */}
                                                                                                <select disabled={!edittrue} name="state" value={userdata.state} onChange={(e) => {
                                                                                                    dataChange(e);
                                                                                                    getallcityfunc(
                                                                                                        e.target.value
                                                                                                    );
                                                                                                }}
                                                                                                    class="form-control dashboard-input-box-3"
                                                                                                    aria-label="Default select example"
                                                                                                >
                                                                                                    {stateLoading ? (
                                                                                                        <option disabled>Loading...</option>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <option value={0}>State</option>
                                                                                                            {statelist &&
                                                                                                                statelist.map((item) => (
                                                                                                                    <option value={item._id} key={item._id}>
                                                                                                                        {item.name}
                                                                                                                    </option>
                                                                                                                ))}
                                                                                                        </>
                                                                                                    )}
                                                                                                </select>
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please enter State
                                                                                                </Form.Control.Feedback>
                                                                                            </div>
                                                                                            <div className="col-4 col-md-3 form-group mb-0" controlid="validationCustom02">
                                                                                                {/* <input type="text" name="state" className="form-control dashboard-input-box-3" value={userdata.state} onChange={(e) => dataChange(e)} placeholder="State" required disabled={!edittrue} />
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please enter State
                                                                                                </Form.Control.Feedback> */}
                                                                                                <select disabled={!edittrue} name="city" value={userdata.city} onChange={(e) => { dataChange(e); }}
                                                                                                    class="form-control dashboard-input-box-3" aria-label="Default select example">
                                                                                                    {cityLoading ? (
                                                                                                        <option disabled>Loading...</option>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <option value={0}>City/Town</option>
                                                                                                            {citylist &&
                                                                                                                citylist.map((item) => (
                                                                                                                    <option value={item._id} key={item._id}>
                                                                                                                        {item.name}
                                                                                                                    </option>
                                                                                                                ))}
                                                                                                        </>
                                                                                                    )}
                                                                                                </select>
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please enter City
                                                                                                </Form.Control.Feedback>
                                                                                            </div>
                                                                                            <div className="col-4 col-md-3 form-group mb-0" controlid="validationCustom02">
                                                                                                <input type="text" name="zip" className="form-control dashboard-input-box-3" value={userdata.zip} onChange={(e) => dataChange(e)} placeholder="Zip Code" required disabled={!edittrue} />
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please enter Zip Code
                                                                                                </Form.Control.Feedback>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </fieldset>

                                                                        </div>
                                                                    </div>
                                                                    <div className="btn-section mt-5 mb-5">
                                                                        <ButtonList />
                                                                    </div>
                                                                </Form>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey="second">

                                                                <>

                                                                    <div class="sec-header-dash dashboard-sec">
                                                                        <div class="sec-dashboard-header-title mb-0"><div class="box-title mb-0" style={{ color: '#ffffff' }}><h3>My Scripts</h3></div></div>
                                                                    </div>

                                                                    <div className="dashboard-sec">
                                                                        <> {
                                                                            remotefitting.length === 0 ? (
                                                                                <div className="no-data-found">
                                                                                    <div className='no-data-img'>
                                                                                        <img src={require("../assets/images/logo_text.png")} alt="" />
                                                                                    </div>
                                                                                    <div className="no-data-text">
                                                                                        <h3>No data Found</h3>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                                :
                                                                                remotefitting.map((item, i) => {
                                                                                    return (
                                                                                        <>
                                                                                            <div className="black_bg_box">
                                                                                                <div className="black_bg_box_inner">
                                                                                                    <div className="left_box_content">
                                                                                                        <div className="list_border_boxs project-list-box">
                                                                                                            <div className="border_box_view">
                                                                                                                <div className="border_box_view_inner">
                                                                                                                    <div className="box_icon">
                                                                                                                        <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g fill="#99ea24"><path d="m25 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><path clip-rule="evenodd" d="m15 9.00001c0-.6707.066-1.32598.1919-1.9597-4.0388.40511-7.1919 3.81419-7.1919 7.95969v39c0 4.4183 3.5817 8 8 8h32c4.4183 0 8-3.5817 8-8v-39c0-4.1455-3.1531-7.55458-7.1919-7.95968.1259.63371.1919 1.28899.1919 1.95969 0 5.52289-4.4771 9.99999-10 9.99999h-14c-5.5228 0-10-4.4771-10-9.99999zm13.4142 18.58579c.7811.781.7811 2.0474 0 2.8284l-6 6c-.432.4321-1.0379.6429-1.6448.5725-.6069-.0705-1.1483-.4145-1.4699-.934l-2-3.2308c-.5814-.9391-.2914-2.1718.6478-2.7532s2.1718-.2913 2.7532.6478l.6709 1.0837 4.2144-4.2144c.781-.7811 2.0474-.7811 2.8284 0zm6.5858 1.4142c-1.1046 0-2 .8954-2 2s.8954 2 2 2h10c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 15c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2zm-4.5858.4142c.7811-.781.7811-2.0474 0-2.8284-.781-.7811-2.0474-.7811-2.8284 0l-4.2144 4.2144-.6709-1.0837c-.5814-.9391-1.814-1.2292-2.7532-.6478s-1.2292 1.8141-.6478 2.7532l2 3.2308c.3216.5195.863.8635 1.4699.934.6069.0704 1.2128-.1404 1.6448-.5725z" fill-rule="evenodd" /></g></svg>
                                                                                                                    </div>
                                                                                                                    <div className="box_text_content">
                                                                                                                        <div className="little_text">Status:</div>
                                                                                                                        <div className="big_text">{getcurrentstage(item.current_stage)}</div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="border_box_view">
                                                                                                                <div className="border_box_view_inner">
                                                                                                                    <div className="box_icon">
                                                                                                                        <FaCalendarAlt />
                                                                                                                    </div>
                                                                                                                    <div className="box_text_content">
                                                                                                                        <div className="little_text">Performed:</div>
                                                                                                                        <div className="big_text">{item && formatDate(item.createdAt)}</div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="right_box_content">
                                                                                                        <div className="box_btn">
                                                                                                            {/* <Link to={`/prescription-view/${item._id}`}> */}
                                                                                                            <button className="btn btn-colr" onClick={() => { checkprec(item._id) }} disabled={loadingButtons[item._id]}>
                                                                                                                {/* {
                                                                                                                    apiNewcall ? <Spinner animation="border" className="border-black" /> : "View Project"
                                                                                                                } */}
                                                                                                                {loadingButtons[item._id] ? (
                                                                                                                    <Spinner animation="border" className="border-black" />
                                                                                                                ) : (
                                                                                                                    "View Project"
                                                                                                                )}
                                                                                                            </button>
                                                                                                            {/* </Link> */}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </>
                                                                                    )
                                                                                }
                                                                                )
                                                                        }
                                                                        </>
                                                                    </div>
                                                                </>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey="third">
                                                                {/* <div className="dashboard-sec">
                                                                    <div className="row">
                                                                        <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                                                                            <div className="store_black_box">
                                                                                <div className="store_box_inner">
                                                                                    <div className="store_image">
                                                                                        <img src={require('../assets/images/map.png')} alt="store" />
                                                                                    </div>
                                                                                    <div className="store_text">
                                                                                        <div className="mb-0">
                                                                                            <div className="step_card_content px-0">
                                                                                                <div className="gab_title">
                                                                                                    <div className="gab_text">
                                                                                                        <small>Fitting</small>
                                                                                                        <h5>Remote Fitting</h5>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="myfitting-btn">
                                                                                                    <button className="btn-dark-open btn btn_default bg-white text-dark">
                                                                                                        Get Started
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                                                                            <div className="store_black_box">
                                                                                <div className="store_box_inner">
                                                                                    <div className="store_image">
                                                                                        <img src={require('../assets/images/map.png')} alt="store" />
                                                                                    </div>
                                                                                    <div className="store_text">
                                                                                        <div className="mb-0">
                                                                                            <div className="step_card_content px-0">
                                                                                                <div className="gab_title">
                                                                                                    <div className="gab_text">
                                                                                                        <small>Fitting</small>
                                                                                                        <h5>Camera</h5>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="myfitting-btn">

                                                                                                    {
                                                                                                        showremotefitting === false ? (<button className="btn-dark-open btn btn_default bg-white text-dark" onClick={creatremotefitting}>
                                                                                                            {
                                                                                                                newapicall ? <Spinner animation="border" className="border-black" /> : "Get Started"
                                                                                                            }

                                                                                                        </button>) : (
                                                                                                            <Link to={`/remote_fittings_camera/${user_id}`}>
                                                                                                                <button className="btn-dark-open btn btn_default bg-white text-dark"> Get Started </button>
                                                                                                            </Link>
                                                                                                        )
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                                                                            <div className="store_black_box">
                                                                                <div className="store_box_inner">
                                                                                    <div className="store_image">
                                                                                        <img src={require('../assets/images/flag.png')} alt="store" />
                                                                                    </div>
                                                                                    <div className="store_text">
                                                                                        <div className="mb-0">
                                                                                            <div className="step_card_content px-0">
                                                                                                <div className="gab_title">
                                                                                                    <div className="gab_text">
                                                                                                        <small>Fitting</small>
                                                                                                        <h5>Come See Us</h5>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="myfitting-btn">
                                                                                                    <button className="btn-dark-open btn btn_default bg-white text-dark">
                                                                                                        Get Started
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div> */}
                                                                {/* <div className="dashboard-sec bookings-tab">
                                                                    <div className="container-fluid">
                                                                        <div className="row">
                                                                            <div className="col-12">
                                                                                <div className="bookings-tab-header py-5">
                                                                                    <div className="container">
                                                                                        <div className="row">
                                                                                            <div className="col-md-12">
                                                                                                <div className="text-center">
                                                                                                    <h1 className="mb-0 text-white" style={{fontWeight:'600'}}>We send it to you</h1>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="row d-flex justify-content-between">
                                                                                    <div className="bookings-tab-main-drop col-12 col-md-6">
                                                                                        <div className="dropdown" >
                                                                                            <div
                                                                                                className="dropdown-header d-flex justify-content-between align-items-center"
                                                                                                onClick={handleToggle}
                                                                                            >
                                                                                                <div>
                                                                                                    <h4 className="mb-0">Remote Fitting</h4>
                                                                                                    <p className="mb-0">Iron Fitting</p>
                                                                                                </div>
                                                                                                <div className="dropdown-arrow1">
                                                                                                    {isOpen ? (
                                                                                                        <FaChevronUp className="dropdown-arrows" />
                                                                                                    ) : (
                                                                                                        <FaChevronDown className="dropdown-arrows" />
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>

                                                                                            {isOpen && (
                                                                                                <div className="dropdown-body text-center">
                                                                                                    <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper my-5">
                                                                                                        <div id="player" className="v-video">
                                                                                                            <iframe
                                                                                                                ref={(el) => (playerRefs.current[0] = el)}
                                                                                                                src="https://player.vimeo.com/video/844417814?h=b2407d1914&badge=0&autopause=0&player_id=0&app_id=58479&controls=1"
                                                                                                                frameborder="0"
                                                                                                                allow="autoplay; fullscreen; picture-in-picture"
                                                                                                                allowfullscreen=""
                                                                                                                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                                                                                                title=""
                                                                                                                data-ready="true"
                                                                                                            ></iframe>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className=" fs-5">
                                                                                                        <div className="">
                                                                                                            We send you our fitting case and you send us the results.
                                                                                                        </div>
                                                                                                        <div className="fw-bold mt-2">$299 for unlimited golfers</div>
                                                                                                    </div>
                                                                                                    <div className="my-5">
                                                                                                        <div className="tick-txt d-flex align-items-center justify-content-center" style={{ fontWeight: 'bold', fontSize: '22px' }}>
                                                                                                            <div className="me-2"><FaCheck /></div>
                                                                                                            <div>Shipping Included</div>
                                                                                                        </div>
                                                                                                        <div className="tick-txt d-flex align-items-center justify-content-center mt-2" style={{ fontWeight: 'bold', fontSize: '22px' }}>
                                                                                                            <div className="me-2"><FaCheck /></div>
                                                                                                            <div>Step By Step Directions</div>
                                                                                                        </div>
                                                                                                        <div className="tick-txt d-flex align-items-center justify-content-center mt-2" style={{ fontWeight: 'bold', fontSize: '22px' }}>
                                                                                                            <div className="me-2"><FaCheck /></div>
                                                                                                            <div>Get The Full Process</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div>
                                                                                                        <button className="btn btn-dark btn-block drop-btn">
                                                                                                            <div className="d-flex flex-column align-items-center">
                                                                                                                <p className="mb-0">To get started</p>
                                                                                                                <h4 className="mb-0">Start Here</h4>
                                                                                                            </div>
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )}

                                                                                            
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="py-5">
                                                                                            <div className="text-center">
                                                                                                    <h1 className="mb-0 text-white" style={{fontWeight:'600'}}>Visit our studio</h1>
                                                                                                </div>
                                                                                            </div>
                                                                                    <div className="bookings-tab-main-drop col-12 col-md-6">
                                                                                        <div className="dropdown" >
                                                                                            <div
                                                                                                className="dropdown-header d-flex justify-content-between align-items-center"
                                                                                                onClick={handleToggle1}
                                                                                            >
                                                                                                <div>
                                                                                                    <h4 className="mb-0">Complete Bag</h4>
                                                                                                    <p className="mb-0">Club Fitting</p>
                                                                                                </div>
                                                                                                <div className="dropdown-arrow">
                                                                                                    {isOpen ? (
                                                                                                        <FaChevronUp className="dropdown-arrows" />
                                                                                                    ) : (
                                                                                                        <FaChevronDown className="dropdown-arrows" />
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="bookings-tab-main-drop col-12 col-md-6 mt-4">
                                                                                        <div className="dropdown" >
                                                                                            <div
                                                                                                className="dropdown-header d-flex justify-content-between align-items-center"
                                                                                                onClick={handleToggle1}
                                                                                            >
                                                                                                <div>
                                                                                                    <h4 className="mb-0">Driver + Woods</h4>
                                                                                                    <p className="mb-0">Club Fitting</p>
                                                                                                </div>
                                                                                                <div className="dropdown-arrow">
                                                                                                    {isOpen ? (
                                                                                                        <FaChevronUp className="dropdown-arrows" />
                                                                                                    ) : (
                                                                                                        <FaChevronDown className="dropdown-arrows" />
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="bookings-tab-main-drop col-12 col-md-6 mt-4">
                                                                                        <div className="dropdown" >
                                                                                            <div
                                                                                                className="dropdown-header d-flex justify-content-between align-items-center"
                                                                                                onClick={handleToggle1}
                                                                                            >
                                                                                                <div>
                                                                                                    <h4 className="mb-0">Irons + Hybrids</h4>
                                                                                                    <p className="mb-0">Club Fitting</p>
                                                                                                </div>
                                                                                                <div className="dropdown-arrow">
                                                                                                    {isOpen ? (
                                                                                                        <FaChevronUp className="dropdown-arrows" />
                                                                                                    ) : (
                                                                                                        <FaChevronDown className="dropdown-arrows" />
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="bookings-tab-main-drop col-12 col-md-6 mt-4">
                                                                                        <div className="dropdown" >
                                                                                            <div
                                                                                                className="dropdown-header d-flex justify-content-between align-items-center"
                                                                                                onClick={handleToggle1}
                                                                                            >
                                                                                                <div>
                                                                                                    <h4 className="mb-0">Wedges</h4>
                                                                                                    <p className="mb-0">Iron Fitting</p>
                                                                                                </div>
                                                                                                <div className="dropdown-arrow">
                                                                                                    {isOpen ? (
                                                                                                        <FaChevronUp className="dropdown-arrows" />
                                                                                                    ) : (
                                                                                                        <FaChevronDown className="dropdown-arrows" />
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="bookings-tab-main-drop col-12 col-md-6 mt-4">
                                                                                        <div className="dropdown" >
                                                                                            <div
                                                                                                className="dropdown-header d-flex justify-content-between align-items-center"
                                                                                                onClick={handleToggle1}
                                                                                            >
                                                                                                <div>
                                                                                                    <h4 className="mb-0">Putter</h4>
                                                                                                    <p className="mb-0">Iron Fitting</p>
                                                                                                </div>
                                                                                                <div className="dropdown-arrow">
                                                                                                    {isOpen ? (
                                                                                                        <FaChevronUp className="dropdown-arrows" />
                                                                                                    ) : (
                                                                                                        <FaChevronDown className="dropdown-arrows" />
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div> */}
                                                                <div className="booking-tab-new-design">

                                                                    <RemoateFitting setuserlogin={(loginusercallback) => setloginusercallback(loginusercallback)} showpopup={showpopup} />
                                                                    <FittingRates />
                                                                </div>
                                                            </Tab.Pane>
                                                        </Tab.Content>
                                                    </div>
                                                </div>
                                            </Tab.Container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >

                <Modal
                    show={show}
                    onHide={handleClose}
                    centered
                    id="success_tic"
                    className='model-thank-you'
                >
                    <Modal.Body>
                        <div className="logo-modal mb-4 text-center">
                            <img src={require('../assets/images/logo_text.png')} alt="logo" />
                        </div>
                        <h3 className="text-center">
                            Customer Edit successfully
                        </h3>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    )
}

const getdate = (dateString) => {

    if (dateString === null) {
        return null
    } else {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const formattedDate = `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}`;
        return formattedDate;
    }
}

const gettime = (dateString) => {
    if (dateString === null || dateString === undefined) {
        return null
    } else {
        const date = new Date(dateString);

        const hours = date.getHours();
        const minutes = date.getMinutes();

        const period = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = String(hours % 12 || 12).padStart(2, '0');
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedDate = `${formattedHours}:${formattedMinutes} ${period}`;

        return formattedDate;
    }
}



const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getUTCDate()).padStart(2, '0');
    const year = String(date.getUTCFullYear()).slice(-2);
    return `${month}/${day}/${year}`;
};


const getcurrentstage = (current_stage) => {
    switch (current_stage) {
        case '0':
            return 'Fitting';
        case '1':
            return 'Perscription';
        case '2':
            return 'Build sheet';
        case '3':
            return 'Staging station';
        case '4':
            return 'Build station';
        case '5':
            return 'Ship station';
        case '6':
            return 'Complete';
        default:
            return ''; // In case the status doesn't match any case
    }
};


export default UserDashboard;